import { Provider } from '@angular/core';
import { LocalizationDataHttpService } from './abstract';
import { LocalizationDataHttpServiceImpl } from './localization-data-http.service';

export const LocalizationDataHttpProvider: Provider = {
	provide: LocalizationDataHttpService,
	useClass: LocalizationDataHttpServiceImpl,
};
